import type { PlanningData } from "@/types/public-data"

interface PlanningCardProps {
  data: PlanningData
}

export default function PlanningCard({ data }: PlanningCardProps) {
  return (
    <div className="rounded-xl border border-stone bg-white p-6">
      <h3 className="font-display text-lg font-semibold text-charcoal">
        Planning Constraints
      </h3>

      <div className="mt-4 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-slate">Conservation areas</span>
          <span className="text-sm font-medium text-charcoal">
            {data.conservationAreas}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-slate">Green belt</span>
          <span className="text-sm font-medium text-charcoal">
            {data.greenBelt > 0 ? "Yes" : "No"}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-slate">Listed buildings</span>
          <span className="text-sm font-medium text-charcoal">
            {data.listedBuildings}
          </span>
        </div>
      </div>
    </div>
  )
}
